import type { TransformedActivityType } from '@/lib/apollo/query/getActivitiesForUser/dataTransformations/types'

export const toActivityTypeLabel = (activityType?: TransformedActivityType): string => {
  if (activityType === undefined) {
    return 'Unknown'
  }

  if (activityType === 'overallVerify') {
    return 'Overall verification'
  }

  return activityType.charAt(0).toUpperCase() + activityType.slice(1)
}
